import { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { checkUserPermission } from "../../../common/UserPermission";

const ReportListData = () => {
  const token = localStorage.getItem("Token");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeIndices, setActiveIndices] = useState([]);
  const [filterTag, setFilterTag] = useState(0); // 0=all, 1=pos, 2=Quickbook
  const [inputValue, setInputValue] = useState("");

  const fetchReportData = async (tag) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.reportsBaseUrl}/reports/gettabledata?filterbytag=${tag}&inputvalue=${inputValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      if (response && response.data?.ResponseData?.[0]) {
        const data = response.data.ResponseData[0];
        setReportData(data);

        const fallUnderKeys = Object.keys(
          data.reduce((acc, report) => {
            const key = report.FallUnder || "Others";
            acc[key] = true;
            return acc;
          }, {})
        );
        setActiveIndices(fallUnderKeys.map((_, idx) => idx));
      }
    } catch (error) {
      console.error("Failed to fetch report data", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchReportData(filterTag);
  }, [filterTag, inputValue]);

  const toggleAccordion = (index) => {
    setActiveIndices((prevIndices) =>
      prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index)
        : [...prevIndices, index]
    );
  };

  const groupedReports = reportData.reduce((acc, report) => {
    const key = report.FallUnder || "Others";
    if (!acc[key]) acc[key] = [];
    acc[key].push(report);
    return acc;
  }, {});

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    setFilterTag(0);
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="row d-flex gap-w-100 mb-3">
        <div className="tab-radio-wrapper d-flex align-items-center justify-content-start col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-12 gap-4">
          {["All Reports", "POS", "Quickbook", "Custom"].map((label, index) => (
            <label
              key={label}
              className={`tab-radio-item ${
                filterTag === index ? "active" : ""
              }`}
            >
              <input
                type="radio"
                name="reportType"
                value={label.toLowerCase()}
                checked={filterTag === index}
                onChange={() => setFilterTag(index)}
                hidden
              />
              {label}
            </label>
          ))}
        </div>

        <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-12 ms-auto">
          <div style={{ margin: "10px", marginBottom: "16px" }}>
            <div className="input-group">
              <input
                type="text"
                placeholder="Search Report By Name"
                value={inputValue}
                onChange={handleInputChange}
                className="form-control form-control-sm border-size-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordionExample">
        {Object.entries(groupedReports).map(([fallUnder, reports], index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header">
              <button
                className={`custom-accorian-header accordion-button ${
                  activeIndices.includes(index) ? "" : "collapsed"
                }`}
                type="button"
                onClick={() => toggleAccordion(index)}
              >
                <i className="fas fa-dot-circle mr-2"></i> {fallUnder}
              </button>
            </h2>
            <div
              className={`accordion-collapse collapse ${
                activeIndices.includes(index) ? "show" : ""
              }`}
              style={{
                maxHeight: activeIndices.includes(index) ? "fit-content" : "0px",
                overflow: "hidden",
                transition: "max-height 0.3s ease",
              }}
            >
              <div className="accordion-body">
                <div className="row">
                  {reports.map((item, idx) =>
                    checkUserPermission(item?.permission) ? (
                      <div
                        className="list-group col-xl-4 col-lg-6 col-md-6 col-12 mb-2"
                        key={idx}
                      >
                        <a
                          className="list-group-item"
                          href={item.URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "14px",
                            color: "var(--primary-color-800)",
                          }}
                        >
                          <i className="icon ti-receipt"></i> {item.ReportName}
                          <span
                            style={{ fontSize: "14px" }}
                            className="float-end"
                          >
                            {item.tag}
                          </span>
                        </a>
                      </div>
                    ) : null
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ReportListData;
